/**
 * @desc 全局参数详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.SysGlobalParamResponseDto>;
export function request(
  params: API.basics.sysGlobalParam.detail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/sysGlobalParam/details`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
